import React, { useMemo } from 'react';
import { useCss } from 'react-use';
import cn from 'classnames';

import { calculateServicePriceRange, calculateServiceTimeRange, formatServiceDuration } from 'bl/services/calculateServicesPriceAndTimeRanges.bl';
import { matchesServiceAndNotDeleted } from 'bl/services/matchesServiceAndNotDeleted.bl';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

import CN from './ServiceItem.module.scss';

const ServiceItem = ({ service, addedServices, onClickService, backgroundColor }) => {
  const { isDarkMode } = useTheme();

  const { low, high } = calculateServiceTimeRange(service);
  const serviceTimeSpend = formatServiceDuration({ from: low, to: high, duration: service?.duration });
  const { minPrice, maxPrice } = calculateServicePriceRange(service);

  const isSelected = fromAnyToBool(addedServices && addedServices.length && addedServices.filter((item) => matchesServiceAndNotDeleted({ item, serviceName: service.name })).length);

  const ctegoryBulletColor = useMemo(() => (backgroundColor ? backgroundColor : service.color), [backgroundColor, service.color]);

  // TODO: see if useCss can be used
  // useCss() cannot reliably override CSS Modules classes specificity and order
  const componentStyle = useMemo(
    () =>
      isSelected
        ? {
            borderColor: ctegoryBulletColor,
            '--after-color': ctegoryBulletColor,
          }
        : undefined,
    [ctegoryBulletColor, isSelected],
  );

  const iconStyleClass = useCss({ color: ctegoryBulletColor });

  const hasOnePrice = fromAnyToBool(minPrice === maxPrice);

  return (
    <div
      data-bem="ServiceItem"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
        [CN.selected]: isSelected,
      })}
    >
      <div onClick={onClickService} role="menuitem" className={CN.item} tabIndex={0} style={componentStyle}>
        <span data-bem="ServiceItem__bullet" className={CN.categoryBuletColor} style={{ backgroundColor: ctegoryBulletColor }} />

        {isSelected && <i data-bem="ServiceItem__icon--selected" className={cn(CN.categoryTickColor, iconStyleClass)} />}

        <span data-bem="ServiceItem__name" className={CN.itemName}>
          {service.name}
        </span>

        <div data-bem="ServiceItem__cost" className={CN.itemCost}>
          <span data-bem="ServiceItem__price">
            {hasOnePrice ? (
              <CurrencySign value={service.price} />
            ) : (
              <span>
                <CurrencySign value={minPrice} />
                {' - '}
                <CurrencySign value={maxPrice} />
              </span>
            )}
          </span>
          <span> . </span>
          <span data-bem="ServiceItem__duration" className="duration-range">
            {serviceTimeSpend}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ServiceItem;
